import { Badge } from "antd-mobile";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

import { CustomNavBar, CustomTabs } from "../../components";
import Announce from "./components/Announce";
import Message from "./components/Message";
import { useGetUnreadCount, useReadAllMessage } from "./hooks/systemAnnoucement.hook";

function SystemAnnouncement() {
  const [nowKey, setNowKey] = useState("");
  const location = useLocation();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const getUnreadCount = useGetUnreadCount({});
  const { mutate: readAllMessage } = useReadAllMessage();
  const rightSideRender = (
    <span
      onClick={async () => {
        await readAllMessage();
      }}
      style={{ color: "--nav-topbar-text" }}
    >
      {t("message.read.all")}
    </span>
  );
  const tabTitleStyle = {
    minWidth: "100px",
    display: "flex",
    justifyContent: "center",
  };
  const tabItems = [
    {
      key: "message",
      title: (
        <div style={tabTitleStyle}>
          <Badge
            content={getUnreadCount.data ? getUnreadCount.data : ""}
            style={{ "--right": "-50%" }}
          >
            {t("personal.systemAnnouncement.message")}
          </Badge>
        </div>
      ),
      component: <Message />,
    },
    {
      key: "announce",
      title: <div style={tabTitleStyle}>{t("personal.systemAnnouncement.announce")}</div>,
      component: <Announce />,
    },
  ];

  const getNowTab = () => {
    const tab = params.get("tab");
    if (tab) {
      const foundTab = tabItems.find((item) => item.key == tab);
      if (foundTab) {
        setNowKey(tab);
      } else {
        setNowKey(tabItems[0].key);
      }
    } else {
      setNowKey(tabItems[0].key);
    }
  };

  useEffect(() => {
    getNowTab();
  }, []);

  return (
    <div>
      <CustomNavBar
        onBack={() => {
          if (location.pathname.includes("personal")) {
            navigate("/personal");
          } else {
            navigate("/home");
          }
        }}
        right={nowKey === "message" ? rightSideRender : ""}
      >
        {t("menu.personal.systemAnnouncement")}
      </CustomNavBar>
      <CustomTabs
        tabItems={tabItems}
        activeKey={nowKey}
        onTabChange={(key) => {
          setNowKey(key);
        }}
      />
    </div>
  );
}

export default SystemAnnouncement;
